import { Box, FloraTag } from '@grupoboticario/flora-react'

import { getTierLabel } from '@/utils/getTierLabel'

type TierSemantic = 'assorted' | 'alert' | 'neutral'

type TierTagProps = {
  tier?: number
}

const TIER_SEMANTIC: Record<number, TierSemantic> = {
  0: 'assorted',
  1: 'alert'
}

const TierTag = ({ tier = 0 }: TierTagProps) => {
  const styleSemantic: TierSemantic = TIER_SEMANTIC[tier] ?? 'neutral'
  const assortedStyle = styleSemantic === 'assorted' ? (9 as const) : undefined

  return (
    <Box>
      <FloraTag size="small" assortedStyle={assortedStyle} styleSemantic={styleSemantic} type="readOnly">
        {getTierLabel(tier)}
      </FloraTag>
    </Box>
  )
}

export default TierTag
